module.exports = "/images/PLA..png?c1c9bd8c2fef9e6dc314b2124247b36b";